import { Box, List, ListItem, Stack } from "@mui/material";

const CodeOfConduct = () => {
  const codeOfConductRules = [
    {
      rule: "Any student who fails to meet any stipulated norms will face disciplinary action which may include his/her term not being granted.",
    },
    {
      rule: "Identity card: The students must wear their identity card when they are inside the college campus. And produce it on demand by the college authority.",
    },
    {
      rule: "Attendance: The students should obtain a minimum attendance percentage with 85% in practical and 80% in theory in each subject. Those students who fail is to satisfy the minimum attendance percentage will not qualify to appear for the MUHS examinations. At times students with less attendance percentage will have to attend extra lectures / exams on holidays in order to derive the minimum attendance percentage.",
    },
    {
      rule: "Mobile phone: The students are instructed strictly; not to use mobile phones in the college campus.",
    },
    {
      rule: "Misbehaviour, Habitual late coming, disobedience, absenteeism, consumption of alcohol& drugs, smoking, chewing pan masala, and malpractice in the exam shall attract immediate cancellation of admission.",
    },
    {
      rule: "Ragging of any sort is strictly prohibited and will be dealt with serious action as per the provision of Maharashtra ragging prohibition act 1999.",
    },
    {
      rule: "Absence for the test/examination/non submission of assignments will make a student non eligible for the internal assessment marks.",
    },
    {
      rule: "Causing any type of damage to the college property or any attachment areas will be an act of indiscipline and such acts will be imposed with severe punishment and the student will have to bear the loss.",
    },
    {
      rule: "Professional dress code standards: The students should be properly dressed and groomed with a professional image. The students should wear a modest casual wear in the campus and should wear aprons for all clinical assignments, any class that is held in a clinical facility and in any class where patients are present.",
    },
  ];
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
        spacing={2}
      >
        <List
          sx={{
            marginLeft: { sx: 2, md: 10 },
            listStyleType: "none",
            paddingLeft: 0,

            "& li": {
              position: "relative",
              paddingLeft: "24px",
            },
            "& li::before": {
              content: '""',
              position: "absolute",
              left: 0,
              top: "50%",
              color: "primary.main",
              transform: "translateY(-50%)",
              width: "6px",
              height: "6px",
              borderRadius: "50%",
              backgroundColor: "currentColor",
            },
          }}
        >
          {codeOfConductRules?.map((listItem, i) => (
            <ListItem key={i} sx={{ display: "flex", alignItems: "center" }}>
              {listItem?.rule}
            </ListItem>
          ))}
        </List>
      </Stack>
    </Box>
  );
};

export default CodeOfConduct;
